<mat-form-field>
  <mat-label>{{ label() }}</mat-label>
  <mat-select #input="ngModel" [(ngModel)]="model" [disabled]="disabled()"
              maxlength="2" [required]="required()">
    @for (country of swedenCountyList; track country.code) {
      <mat-option
        [disabled]="exclude().includes(country.code)"
        [class]="{'separator-after': $index === 0}"
        [value]="country.code">{{ country.name }}
      </mat-option>
    } @empty {
      <mat-option disabled>Inga länder tillgängliga</mat-option>
    }

  </mat-select>
  @if (input.errors) {
    <mat-error>Vänligen gör ett val</mat-error>
  }

  @if (input.errors && input.touched) {
    <mat-icon matIconSuffix aria-hidden="true">
      priority_high
    </mat-icon>
  }

</mat-form-field>
